import { ofType } from 'redux-observable';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions } from '../../reducers/actions';
import { TagService } from '../../services';
import { addedTagAction } from '../../reducers/actions';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function(action$, store) {
  return action$.pipe(
    ofType(actions.ADD_TAG),
    switchMap(action =>
      TagService.create(action.tag, store).pipe(
        map(data => addedTagAction(data)),
        catchError(retryAuthentication(action$, 'epics/tags/addTag'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/tags/addTag.js